import { cn } from '@/lib/utils'

interface AvatarProps {
  name: string
  className?: string
}

export function Avatar({ name, className }: AvatarProps) {
  // Get first two letters of name
  const initials = (name || '?')
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)

  // Generate consistent color based on name
  const getColorFromName = (str: string) => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    const colors = [
      'bg-red-500',
      'bg-orange-500',
      'bg-amber-500',
      'bg-yellow-500',
      'bg-lime-500',
      'bg-green-500',
      'bg-emerald-500',
      'bg-teal-500',
      'bg-cyan-500',
      'bg-sky-500',
      'bg-blue-500',
      'bg-indigo-500',
      'bg-violet-500',
      'bg-purple-500',
      'bg-fuchsia-500',
      'bg-pink-500',
      'bg-rose-500',
    ]
    return colors[Math.abs(hash) % colors.length]
  }

  const bgColor = getColorFromName(name || '?')

  return (
    <div
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-full text-white text-xs font-medium',
        bgColor,
        className
      )}
    >
      {initials}
    </div>
  )
}
